import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["checked", "disabled", "aria-checked", "aria-label"]
const _hoisted_2 = {
  class: "ui-checkbox__control",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "ui-checkbox__icon",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = {
  key: 1,
  class: "ui-checkbox__icon",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-checkbox__copy"
}
const _hoisted_6 = {
  key: 0,
  class: "ui-checkbox__label"
}
const _hoisted_7 = {
  key: 1,
  class: "ui-checkbox__description"
}

import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { default: '' },
    description: { default: '' },
    ariaLabel: { default: '' },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const inputRef = ref<HTMLInputElement | null>(null);

const rootClasses = computed(() => [
  'ui-checkbox',
  {
    'is-checked': props.modelValue && !props.indeterminate,
    'is-indeterminate': props.indeterminate,
    'is-disabled': props.disabled
  }
]);

const resolvedAriaLabel = computed(() => props.ariaLabel || props.label || 'Checkbox');

function handleChange(event: Event): void {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
  emit('change', target.checked);
}

function focus(): void {
  inputRef.value?.focus();
}

__expose({ focus });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(rootClasses.value)
  }, [
    _createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      class: "ui-checkbox__input",
      type: "checkbox",
      checked: __props.modelValue,
      disabled: __props.disabled,
      "aria-checked": __props.indeterminate ? 'mixed' : (__props.modelValue ? 'true' : 'false'),
      "aria-label": resolvedAriaLabel.value,
      onChange: handleChange,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (emit('focus', $event))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (emit('blur', $event)))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    _createElementVNode("span", _hoisted_2, [
      (__props.indeterminate)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("path", {
              d: "M2.5 6H9.5",
              stroke: "currentColor",
              "stroke-width": "1.75",
              "stroke-linecap": "round"
            }, null, -1 /* CACHED */)
          ]))]))
        : (__props.modelValue)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("path", {
                d: "M2.5 6.2L4.8 8.5L9.5 3.5",
                stroke: "currentColor",
                "stroke-width": "1.75",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true)
    ]),
    (__props.label || __props.description || _ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          (__props.label || _ctx.$slots.default)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _createTextVNode(_toDisplayString(__props.label), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (__props.description)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.description), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})